import { Icon } from './Icon';

/** Править: карандаш под 45°, как на карточке внешки в макете. */
export function PencilIcon({ size }: { size?: number }) {
  return (
    <Icon size={size}>
      <path d="M9.6 1.9 L12.1 4.4 L4.6 11.9 L1.6 12.4 L2.1 9.4 Z" />
    </Icon>
  );
}
